var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdexLogoClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AdEx_symbol_main_50x50",
    "data-name": "AdEx_symbol_main 50x50",
    transform: "translate(11690 -7968)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1561",
    "data-name": "Rectangle 1561",
    width: 50,
    height: 50,
    transform: "translate(-11690 7968)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    transform: "translate(-9173.906 5471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M3076.23,5008.444l8.1-8.095-8.095-8.094,4.805-4.8,8.1,8.1,8.1-8.1,4.8,4.8-8.095,8.094,8.094,8.095-4.811,4.811-8.094-8.094-8.095,8.095Z",
    transform: "translate(-5580.229 -2478.349)",
    fill: "#7298fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(-2498.65 2501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M4080.26,3474.726l7.556-7.556,7.556,7.556-4.054,4.054-3.5-3.5-3.5,3.5Z",
    transform: "translate(-4080.26 -3467.17)",
    fill: "#2855cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M4080.26,9174.684l7.556,7.557,7.556-7.557-4.054-4.054-3.5,3.5-3.5-3.5Z",
    transform: "translate(-4080.26 -9140.239)",
    fill: "#2855cc",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdexLogoClean);
export default __webpack_public_path__ + "static/media/adex-logo-clean.de4935d1578674e9c3b1dc44e697052c.svg";
export { ForwardRef as ReactComponent };